import Header from "../../components/Header";
import Footer from "../../components/Footer";

export default function Community() {
    return (
        <>
            <Header />
            <main>
                <section class="pad breadcrumbs top-cover">
                    <div id="breadcrumb" class="content">
                        <a href="Home">Home</a><i></i>
                        <span>NuGensis Community Ownership NFT Design Philosophy</span>
                    </div>
                </section>


                <section class="pad bank-benefits default">
                
                    <div class="content normal">
                    <div data-lavalamp=""></div>
                    
                        <div class="data">
                            <div class="text">
                                <h3 class="title">NuGensis Community Ownership NFT Design Philosophy</h3>
                                <p class="subtitle">
                                NFT Investor Report- Historic data about NFT's and
blockchain. Explaining Nugenesis's business strategy and the
Meta Realm.
                                </p>

                            </div>
                            
                        </div>
                        <div class="img-frame">
                            <img src="images/nugenesisou/pr-illustration-2.png" alt="" />
                        </div>
                    </div>
                    
                </section>

                <section class="pad bank-benefits white">
            <div class="content normal">
                <div class="data">
                    <div class="text">
                        <h3 class="title">TheNuGenNFT release proposes to offer holders, the benefits of</h3>
                        <p class="subtitle">
                                    Equity holding equivalent in the NuGenesis group of companies that support the NuGenesis ecosystem. <br></br><br></br>
                                    Equity holding in key up-coming promising inventions that could revolutionise their industry. <br></br><br></br>
                                    White-list and early release of new tokens and digital assets that are to be released
                                    on the NuGenesis ecosystem, tradeable on LedgerX exchange and other exchange.

                        </p>
                        <div class="btns">
                        </div>
                    </div>
                </div>
                <div class="img-frame">
                <img src="images/nugenesisou/pr-illustration-8.jpg" alt="" />
                </div>
            </div>
            
        </section>

            </main>
            <Footer />
        </>
    )
}